export default {
  segment_labels: {
    active: 'Aktive',
    cancelled: 'Annullerede',
    completed: 'Gennemførte',
  },
};
